import { render, staticRenderFns } from "./vehicleinspectionviewdetails.vue?vue&type=template&id=1d5426b0&scoped=true"
import script from "./vehicleinspectionviewdetails.vue?vue&type=script&lang=js"
export * from "./vehicleinspectionviewdetails.vue?vue&type=script&lang=js"
import style0 from "./vehicleinspectionviewdetails.vue?vue&type=style&index=0&id=1d5426b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5426b0",
  null
  
)

export default component.exports